import React from "react";
import { Img } from "../../../subComponents/img";
import { Heading } from "../../../subComponents/Heading";
import { Text } from "../../../subComponents/text";

const BlogHeroSection = ({ pagetitle, pagedescription, imageUrl, white }) => {
  return (
    <>
      <section className="blog_hero_section">
        <div className="blog_hero_banner">
          <Img src={imageUrl} alt={imageUrl}  />
        </div>
        <div className="blog_hero_banner_overlay">
          <div className="innerblog_hero_content">
            <Heading title={pagetitle} style={{ color: white }} />
            <Text text={pagedescription} />
          </div>
        </div>
      </section>
    </>
  );
};
export { BlogHeroSection };
